import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import * as qs from 'qs';

export default function useQueryAPI(queryKey, apiFn, options = {}) {
  const getHeaders = () => ({
    'X-Correlation-ID': uuidv4(),
    'content-type': 'application/json',
  });

  const queryFn = async () => {
    const response = await apiFn()({
      headers: getHeaders(),
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      withCredentials: true,
    });
    return response.data;
  };

  return useQuery({
    queryKey,
    queryFn,
    staleTime: 60 * 60 * 1000, // 1 hour
    cacheTime: 6 * 60 * 60 * 1000, // 6 hours
    refetchOnWindowFocus: false,
    ...options,
  });
}
